// src/components/cart/EmptyCart.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../common/Button';

/**
 * Empty Cart Component
 * 
 * Displayed when cart is empty
 */
const EmptyCart = () => {
  return (
    <div className="text-center py-16">
      <svg
        className="mx-auto h-32 w-32 text-gray-400"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
      
      <h2 className="mt-6 text-2xl font-bold text-gray-900">
        Your cart is empty
      </h2>
      
      <p className="mt-2 text-gray-600">
        Looks like you haven't added anything to your cart yet
      </p>
      
      <div className="mt-8 flex justify-center">
        <Link to="/products">
          <Button size="lg">
            Start Shopping
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default EmptyCart;